import React from "react";
import { Container, Card, Button } from "react-bootstrap";
import PageLayout from "../Layouts/PageLayout";
import LeftArrow from "../Assets/Icons/leftArrow.svg";
import ProfileImg from "../Assets/Images/ProfileImg.png";
import InActiveIcon from "../Assets/Icons/inActiveIcon.svg"


export default function MerchantAccountInActive() {
  return (
    <Container fluid>
      <PageLayout>
        <div className="backmerchant-acc-sec">
          <img src={LeftArrow} />
          <p>Back</p>
        </div>
        <h4 style={{fontSize: '1.125rem', fontWeight: '600', marginTop: '2.5rem'}}>Merchant</h4>
        <div>
          <Card
            style={{ paddingBottom: "4rem", marginTop: '1rem' }}
            className="merchant-profile-card"
          >
            <div className="merchant-profile-sec-one">
              <div className="merchant-profile-profile">
                <img src={ProfileImg} />
                <div className="merchant-profile-info">
                    <p>Admin Name</p>
                  <div className="merchant-active-status">
                    <img src={InActiveIcon} />
                    <h5 style={{color: '#FF0000'}}>Inactive</h5>
                  </div>
                </div>
              </div>
              <div className="merchant-profile-btns">
                <Button variant='primary'>Activate Account</Button>
                <Button variant="dark">Send Mail</Button>
              </div>
            </div>
            <div className="merchant-profile-divider"></div>
            <div className="merchant-profile-details">
              <div className="merchant-profile-details-sec-con">
                <div className="merchant-profile-details-sec">
                  <p>Name</p>
                  <h2>Naseem Muneer</h2>
                </div>
                <div className="merchant-profile-details-sec">
                  <p>Address</p>
                  <h2>Islamabad, Pakistan</h2>
                </div>
                <div className="merchant-profile-details-sec">
                  <p>Country</p>
                  <h2>Pakistan</h2>
                </div>
              </div>
              <div className="merchant-profile-details-sec-con">
                <div className="profile-details-sec">
                  <p>Email Address</p>
                  <h2>naseembaloch7524@gmail.com</h2>
                </div>
                <div className="merchant-profile-details-sec">
                  <p>Phone Number</p>
                  <h2>+923160598938</h2>
                </div>
                <div className="merchant-profile-details-sec">
                  <p>Shop Address</p>
                  <h2>Islamabad, Pakistan</h2>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </PageLayout>
    </Container>
  );
}
